import React from "react";
import Navbar from "./Navbar";
import AIChat from "./chatAI/AIChat";

const Layout = ({ children }) => {
  return (
    <div className="flex flex-col min-h-screen font-sans bg-gray-50 text-gray-900">
      
      {/* Global Navbar */}
      <Navbar />

      {/* Page content */}
      <main className="flex-grow">
        {children}  {/* Renders Homepage, DeliveryCalculator, or any wrapped page */}
      </main>

      {/* Floating AI Chat */}
      <AIChat />

        {/* Floating WhatsApp Button */}
      <a
  href="https://wa.me/919905306080"
  className="fixed bottom-6 left-6 bg-green-600 hover:bg-green-700 text-white p-4 rounded-full shadow-lg z-[9999] flex items-center justify-center text-2xl transition-transform transform hover:scale-110"
  target="_blank"
  rel="noopener noreferrer"
>
  <i className="fa-brands fa-whatsapp"></i>
</a>

     {/* Global Footer */}
<footer className="bg-gray-800 text-gray-200 py-8 text-center mt-8">
  <p>&copy; 2025 Anil Flyash Bricks. All Rights Reserved.</p>

  {/* Policies */}
  <div className="mt-4 space-x-6">
  <a href="/privacy-policy" className="hover:underline">Privacy Policy</a>
  <a href="/refund-policy" className="hover:underline">Refund Policy</a>
  <a href="/shipping-policy" className="hover:underline">Shipping Policy</a>
  <a href="/terms-conditions" className="hover:underline">Terms & Conditions</a>
</div>

  {/* Social Media Links */}
  <div className="mt-6 flex justify-center space-x-6 text-2xl">
    <a href="https://www.facebook.com/profile.php?id=100084771805332" target="_blank" rel="noopener noreferrer" className="hover:text-blue-500">
      <i className="fab fa-facebook-f"></i>
    </a>
    <a href="https://www.instagram.com/YourPage" target="_blank" rel="noopener noreferrer" className="hover:text-pink-500">
      <i className="fab fa-instagram"></i>
    </a>
    <a href="https://www.youtube.com/@anilflyashbricks8582" target="_blank" rel="noopener noreferrer" className="hover:text-red-600">
      <i className="fab fa-youtube"></i>
    </a>
    <a href="https://wa.me/919905306080" target="_blank" rel="noopener noreferrer" className="hover:text-green-500">
      <i className="fab fa-whatsapp"></i>
    </a>
  </div>
</footer>

    </div>
  );
};

export default Layout;
